import { render, staticRenderFns } from "./TaskDataframesConfiguration.vue?vue&type=template&id=97cb8838&"
import script from "./TaskDataframesConfiguration.vue?vue&type=script&lang=ts&"
export * from "./TaskDataframesConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports